import { useRouter } from 'next/router';
import { useMutation } from '@tanstack/react-query';

import { useToast } from '@paid-ui/ui/toast';
import { request } from '@paid-ui/utils/axios';

import { inviteReasons } from '../constants/invite-reason';
import { InviteJoinReason } from '../models/enums';

interface SendJoinEmailFormValues {
  inviterName: string;
  inviteeEmail: string;
  inviteJoinReason: InviteJoinReason;
}

export const useSendJoinEmail = () => {
  const toast = useToast();
  const router = useRouter();

  return useMutation({
    mutationKey: ['SendJoinEmail'],
    mutationFn: async (values: SendJoinEmailFormValues) => {
      const { inviteJoinReason } = values;
      const { data } = await request.post<null>('/validate/send-join-email', {
        ...values,
        inviteJoinReason:
          inviteJoinReason === InviteJoinReason.EMPLOYEE_INVITE_TRUSTEE
            ? InviteJoinReason.EMPLOYEE_INVITE_DIRECTOR
            : inviteJoinReason,
      });
      return data;
    },
    onSuccess: async (_, params) => {
      try {
        const { inviteJoinReason, inviteeEmail } = params;
        await request.post<null>('/auth/signup/track', {
          email: inviteeEmail,
          reason: inviteReasons[inviteJoinReason],
        });
      } finally {
        router.replace('/signin');
        toast.success('The invitation email has been sent.');
      }
    },
    onError: (error) => {
      toast.error(error instanceof Error ? error.message : 'Failed to send join email.');
    },
  });
};
